import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

// actions
import { getPluginsList } from '../../../actions/plugins'
import { getTvSettings, saveTvSettings } from '../../../actions/tvSettings'
import { startLoading, stopLoading } from '../../../actions/loading'

// local components
import TvDisplay from '../../../components/TvDisplay'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'

const TvDisplayEditable = EditableHOCWrapper(TvDisplay)

class TvDisplayContainer extends PureComponent {
  componentDidMount() {
    this.props.dispatch(getPluginsList())
    this.props.dispatch(getTvSettings())
  }

  onSave = (data, afterOnSave) => {
    this.props.dispatch(startLoading())

    this.props.dispatch(saveTvSettings(data)).then((response) => {
      afterOnSave(response)
      this.props.dispatch(stopLoading())
    })
  }

  render() {
    const { list } = this.props.pluginsReducer

    const { tvSettings, lastModified } = this.props.tvSettingsReducer

    return (
      <TvDisplayEditable
        list={list}
        dataToEdit={tvSettings}
        lastModified={lastModified}
        onSave={this.onSave}
      />
    )
  }
}

const TvDisplayWithTitle = ContainerWithTitle(TvDisplayContainer, 'TV Display')
const TvDisplayConnected = connect(({ dispatch, pluginsReducer, tvSettingsReducer }) => ({
  dispatch,
  pluginsReducer,
  tvSettingsReducer,
}))(TvDisplayWithTitle)

export default TvDisplayConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Plugins/TvDisplay.js